var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 28 L 37 28 L 37 43 L 24 43 Z M 24 28 "
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.414062 28.863281 L 25.125 31.921875 C 24.929688 32.042969 24.804688 32.238281 24.804688 32.46875 L 24.804688 38.578125 C 24.804688 38.804688 24.929688 39.019531 25.125 39.125 L 30.414062 42.179688 C 30.613281 42.285156 30.855469 42.285156 31.054688 42.179688 L 36.34375 39.125 C 36.539062 39.003906 36.664062 38.804688 36.664062 38.578125 L 36.664062 32.46875 C 36.664062 32.238281 36.539062 32.027344 36.34375 31.921875 L 31.054688 28.863281 C 30.945312 28.804688 30.839844 28.773438 30.734375 28.773438 C 30.628906 28.773438 30.523438 28.804688 30.414062 28.863281 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3773,
    y1: -0.0470335,
    x2: 0.9962,
    y2: -0.0470335,
    gradientTransform: "matrix(-12.336624,25.166625,-25.166625,-12.336624,38.024502,17.666139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(33.333333%,57.647059%,30.980392%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "rgb(35.294118%,67.843137%,27.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(35.294118%,67.843137%,27.058824%)",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 28 L 37 28 L 37 43 L 24 43 Z M 24 28 "
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.941406 38.957031 C 24.988281 39.019531 25.050781 39.078125 25.125 39.125 L 29.65625 41.738281 L 30.414062 42.179688 C 30.523438 42.242188 30.660156 42.269531 30.78125 42.257812 C 30.824219 42.257812 30.871094 42.242188 30.902344 42.226562 L 36.480469 32.027344 C 36.433594 31.980469 36.390625 31.933594 36.328125 31.90625 L 32.863281 29.914062 L 31.039062 28.863281 C 30.992188 28.835938 30.933594 28.820312 30.871094 28.804688 Z M 24.941406 38.957031 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0.050268,
    y1: 0.1331,
    x2: 0.6691,
    y2: 0.1331,
    gradientTransform: "matrix(22.466968,-16.600422,16.600422,22.466968,20.426018,38.510218)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "rgb(38.039216%,59.607843%,34.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.27451%,67.45098%,39.215686%)",
      stopOpacity: 1
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 28 L 37 28 L 37 43 L 25 43 Z M 25 28 "
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.671875 28.773438 C 30.582031 28.789062 30.492188 28.804688 30.414062 28.847656 L 25.140625 31.890625 L 30.824219 42.242188 C 30.902344 42.226562 30.976562 42.210938 31.054688 42.164062 L 36.34375 39.109375 C 36.511719 39.019531 36.617188 38.851562 36.648438 38.667969 L 30.855469 28.789062 C 30.808594 28.773438 30.765625 28.773438 30.734375 28.773438 C 30.703125 28.773438 30.6875 28.773438 30.671875 28.773438 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1301,
    y1: 0.2836,
    x2: 0.7489,
    y2: 0.2836,
    gradientTransform: "matrix(18.581058,0,0,18.581058,22.731053,30.242361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(41.960784%,74.901961%,27.843137%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "rgb(41.960784%,74.901961%,27.843137%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "rgb(47.45098%,70.588235%,38.039216%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(45.882353%,67.45098%,39.215686%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(39.607843%,61.960784%,35.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 37.679688 54.992188 C 37.5 54.992188 37.316406 54.949219 37.148438 54.855469 L 35.476562 53.867188 C 35.234375 53.730469 35.355469 53.6875 35.429688 53.65625 C 35.765625 53.535156 35.828125 53.519531 36.191406 53.304688 C 36.222656 53.292969 36.28125 53.292969 36.3125 53.320312 L 37.605469 54.082031 C 37.652344 54.113281 37.710938 54.113281 37.757812 54.082031 L 42.773438 51.195312 C 42.820312 51.164062 42.847656 51.117188 42.847656 51.058594 L 42.847656 45.28125 C 42.847656 45.21875 42.820312 45.175781 42.773438 45.144531 L 37.773438 42.257812 C 37.726562 42.226562 37.664062 42.226562 37.621094 42.257812 L 32.621094 45.144531 C 32.574219 45.175781 32.542969 45.21875 32.542969 45.28125 L 32.542969 51.058594 C 32.542969 51.117188 32.574219 51.164062 32.621094 51.195312 L 33.988281 51.984375 C 34.730469 52.363281 35.1875 51.921875 35.1875 51.480469 L 35.1875 45.753906 C 35.1875 45.675781 35.25 45.613281 35.339844 45.613281 L 35.976562 45.613281 C 36.054688 45.613281 36.113281 45.675781 36.113281 45.753906 L 36.113281 51.46875 C 36.113281 52.457031 35.566406 53.03125 34.625 53.03125 C 34.335938 53.03125 34.109375 53.03125 33.46875 52.714844 L 32.164062 51.953125 C 31.84375 51.769531 31.632812 51.421875 31.632812 51.042969 L 31.632812 45.265625 C 31.632812 44.886719 31.828125 44.535156 32.164062 44.355469 L 37.179688 41.464844 C 37.5 41.28125 37.925781 41.28125 38.226562 41.464844 L 43.242188 44.355469 C 43.5625 44.535156 43.777344 44.886719 43.777344 45.265625 L 43.777344 51.042969 C 43.777344 51.421875 43.578125 51.769531 43.242188 51.953125 L 38.226562 54.839844 C 38.046875 54.933594 37.863281 54.992188 37.679688 54.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 39.230469 51.011719 C 37.042969 51.011719 36.585938 50.007812 36.585938 49.15625 C 36.585938 49.082031 36.648438 49.019531 36.738281 49.019531 L 37.390625 49.019531 C 37.46875 49.019531 37.527344 49.066406 37.527344 49.140625 C 37.621094 49.796875 37.925781 50.128906 39.246094 50.128906 C 40.296875 50.128906 40.75 49.886719 40.75 49.324219 C 40.75 49.003906 40.628906 48.761719 38.988281 48.59375 C 37.621094 48.457031 36.769531 48.152344 36.769531 47.058594 C 36.769531 46.039062 37.621094 45.449219 39.046875 45.449219 C 40.660156 45.449219 41.449219 46.011719 41.542969 47.195312 C 41.542969 47.242188 41.527344 47.273438 41.496094 47.300781 C 41.464844 47.332031 41.433594 47.347656 41.390625 47.347656 L 40.734375 47.347656 C 40.675781 47.347656 40.613281 47.300781 40.597656 47.242188 C 40.445312 46.542969 40.066406 46.328125 39.035156 46.328125 C 37.878906 46.328125 37.742188 46.726562 37.742188 47.027344 C 37.742188 47.394531 37.894531 47.5 39.460938 47.710938 C 40.996094 47.910156 41.722656 48.199219 41.722656 49.292969 C 41.722656 50.386719 40.8125 51.011719 39.230469 51.011719 M 45.328125 44.886719 L 45.492188 44.886719 C 45.628906 44.886719 45.660156 44.792969 45.660156 44.734375 C 45.660156 44.582031 45.554688 44.582031 45.507812 44.582031 L 45.339844 44.582031 Z M 45.113281 44.398438 L 45.492188 44.398438 C 45.613281 44.398438 45.875 44.398438 45.875 44.6875 C 45.875 44.886719 45.753906 44.929688 45.675781 44.945312 C 45.828125 44.960938 45.828125 45.054688 45.859375 45.191406 C 45.875 45.28125 45.890625 45.433594 45.917969 45.476562 L 45.691406 45.476562 C 45.691406 45.433594 45.644531 45.160156 45.644531 45.144531 C 45.628906 45.082031 45.613281 45.054688 45.539062 45.054688 L 45.355469 45.054688 L 45.355469 45.492188 L 45.144531 45.492188 L 45.144531 44.398438 Z M 44.671875 44.945312 C 44.671875 45.402344 45.039062 45.753906 45.476562 45.753906 C 45.933594 45.753906 46.285156 45.386719 46.285156 44.945312 C 46.285156 44.492188 45.917969 44.140625 45.476562 44.140625 C 45.039062 44.140625 44.671875 44.492188 44.671875 44.945312 M 46.453125 44.945312 C 46.453125 45.476562 46.011719 45.917969 45.476562 45.917969 C 44.945312 45.917969 44.503906 45.492188 44.503906 44.945312 C 44.503906 44.398438 44.960938 43.972656 45.476562 43.972656 C 45.996094 43.988281 46.453125 44.398438 46.453125 44.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.098039%,25.490196%,21.568627%)",
      fillOpacity: 1
    },
    d: "M 22.160156 32.359375 C 22.160156 32.132812 22.039062 31.921875 21.84375 31.796875 L 16.539062 28.742188 C 16.445312 28.699219 16.339844 28.667969 16.25 28.652344 L 16.1875 28.652344 C 16.082031 28.652344 15.992188 28.683594 15.898438 28.742188 L 10.59375 31.796875 C 10.398438 31.921875 10.273438 32.132812 10.273438 32.359375 L 10.289062 40.597656 C 10.289062 40.722656 10.351562 40.828125 10.441406 40.871094 C 10.535156 40.933594 10.671875 40.933594 10.761719 40.871094 L 13.90625 39.0625 C 14.105469 38.941406 14.226562 38.730469 14.226562 38.5 L 14.226562 34.65625 C 14.226562 34.429688 14.347656 34.214844 14.546875 34.09375 L 15.882812 33.320312 C 15.992188 33.257812 16.097656 33.226562 16.203125 33.226562 C 16.308594 33.226562 16.429688 33.257812 16.523438 33.320312 L 17.859375 34.09375 C 18.058594 34.214844 18.179688 34.414062 18.179688 34.65625 L 18.179688 38.5 C 18.179688 38.730469 18.300781 38.941406 18.5 39.0625 L 21.660156 40.871094 C 21.765625 40.933594 21.886719 40.933594 21.980469 40.871094 C 22.070312 40.8125 22.132812 40.707031 22.132812 40.597656 Z M 47.226562 36.648438 C 47.226562 36.707031 47.195312 36.753906 47.152344 36.785156 L 45.328125 37.832031 C 45.28125 37.863281 45.21875 37.863281 45.160156 37.832031 L 43.335938 36.785156 C 43.289062 36.753906 43.257812 36.707031 43.257812 36.648438 L 43.257812 34.535156 C 43.257812 34.472656 43.289062 34.429688 43.335938 34.398438 L 45.160156 33.347656 C 45.203125 33.320312 45.265625 33.320312 45.328125 33.347656 L 47.152344 34.398438 C 47.195312 34.429688 47.226562 34.472656 47.226562 34.535156 Z M 47.726562 21.050781 C 47.621094 20.992188 47.5 20.992188 47.410156 21.050781 C 47.316406 21.113281 47.257812 21.21875 47.257812 21.324219 L 47.257812 29.488281 C 47.257812 29.5625 47.210938 29.640625 47.152344 29.6875 C 47.074219 29.730469 47 29.730469 46.921875 29.6875 L 45.585938 28.925781 C 45.386719 28.804688 45.144531 28.804688 44.945312 28.925781 L 39.625 31.996094 C 39.429688 32.117188 39.308594 32.316406 39.308594 32.542969 L 39.308594 38.683594 C 39.308594 38.910156 39.429688 39.125 39.625 39.246094 L 44.945312 42.316406 C 45.144531 42.4375 45.386719 42.4375 45.585938 42.316406 L 50.90625 39.246094 C 51.101562 39.125 51.222656 38.925781 51.222656 38.683594 L 51.222656 23.378906 C 51.222656 23.148438 51.101562 22.9375 50.890625 22.816406 Z M 65.421875 34.488281 C 65.617188 34.367188 65.738281 34.167969 65.738281 33.941406 L 65.738281 32.453125 C 65.738281 32.222656 65.617188 32.011719 65.421875 31.890625 L 60.144531 28.820312 C 59.949219 28.699219 59.707031 28.699219 59.507812 28.820312 L 54.1875 31.890625 C 53.992188 32.011719 53.867188 32.207031 53.867188 32.453125 L 53.867188 38.578125 C 53.867188 38.804688 53.992188 39.019531 54.1875 39.140625 L 59.460938 42.148438 C 59.660156 42.257812 59.886719 42.257812 60.085938 42.148438 L 63.277344 40.371094 C 63.382812 40.308594 63.445312 40.203125 63.445312 40.097656 C 63.445312 39.976562 63.382812 39.871094 63.277344 39.824219 L 57.925781 36.753906 C 57.820312 36.691406 57.761719 36.585938 57.761719 36.480469 L 57.761719 34.550781 C 57.761719 34.429688 57.820312 34.320312 57.925781 34.277344 L 59.585938 33.320312 C 59.691406 33.257812 59.8125 33.257812 59.902344 33.320312 L 61.558594 34.277344 C 61.667969 34.335938 61.726562 34.441406 61.726562 34.550781 L 61.726562 36.070312 C 61.726562 36.191406 61.789062 36.296875 61.894531 36.34375 C 62 36.402344 62.121094 36.402344 62.214844 36.34375 Z M 65.421875 34.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 59.734375 34.199219 C 59.765625 34.183594 59.828125 34.183594 59.859375 34.199219 L 60.875 34.792969 C 60.921875 34.808594 60.9375 34.855469 60.9375 34.898438 L 60.9375 36.070312 C 60.9375 36.113281 60.90625 36.160156 60.875 36.175781 L 59.859375 36.769531 C 59.8125 36.785156 59.765625 36.785156 59.734375 36.769531 L 58.71875 36.175781 C 58.671875 36.160156 58.65625 36.113281 58.65625 36.070312 L 58.65625 34.898438 C 58.65625 34.855469 58.671875 34.808594 58.71875 34.792969 Z M 59.734375 34.199219 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 41.996094 31.386719 L 27.101562 24.09375 L 19.472656 39.671875 L 34.367188 46.96875 Z M 41.996094 31.386719 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 18.511719 33.546875 L 29.015625 47.773438 L 42.925781 37.511719 L 32.40625 23.269531 Z M 18.511719 33.546875 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 25.15625 28.773438 L 36.648438 28.773438 L 36.648438 42.242188 L 25.15625 42.242188 Z M 25.15625 28.773438 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.db6f980572357452ce7481dae6fedc24.svg";
export { ForwardRef as ReactComponent };